import { encode as base64_encode } from 'base-64';
import { postApi, baseURL } from '../components/Utility'
import {
    action,
    makeObservable,
    observable,
} from 'mobx';

class FuelDropReportStore {
    loading = false
    fuelDropReport = []
    rootStore

    constructor(rootStore) {
        makeObservable(this, {
            fuelDropReport: observable,
            loadData: action,
            exportExcel: action,
            exportpdf: action,
            invalidateData: action
        });
        this.rootStore = rootStore;

    }

    async loadData({ companyId, vehicleId, offset, limit, driverId, fromDate, toDate, pageNo }) {
        this.loading = true
        var postData = { "companyId": companyId, "vehicleId": vehicleId, "fromDate": fromDate, "toDate": toDate, "offset": offset, "limit": limit, "page": pageNo }

        const base64Input = await base64_encode(JSON.stringify(postData));

        var response = await postApi.getClient().post("index.php?c=fuel&a=fuelDropRep", "postData=" + base64Input);

        this.fuelDropReport = response?.data?.data?.fueldrop;
        this.total = response?.data?.data?.TotalCount
        this.loading = false
    }

    async invalidateData(data) {
        var postData = data
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi.getClient().post("index.php?c=fuel&a=updateInvalidFuel", "postData=" + base64Input);
        return response
    }


    async exportExcel(getData) {
        let lang = "english";
        window.location.href =
            baseURL +
            "index.php?c=fuel&a=exportfuelDropRepexcel&cid=" +
            getData.companyId +
            "&userId=" +
            getData.userId +
            "&vid=" +
            getData.vehicleId +
            "&fD=" +
            getData.fromDate +
            "&tD=" +
            getData.toDate +
            "&colList=" +
            getData.colList +
            "&language=" +
            lang;
    }

    async exportpdf(getData) {
        let lang = "english";
        window.location.href =
            baseURL +
            "index.php?c=fuel&a=exportfuelDropRepPdf&cid=" +
            getData.companyId +
            "&userId=" +
            getData.userId +
            "&vid=" +
            getData.vehicleId +
            "&fD=" +
            getData.fromDate +
            "&tD=" +
            getData.toDate +
            "&colList=" +
            getData.colList +
            "&language=" +
            lang;
    }
}

export default FuelDropReportStore;
